import i18next from "../i18n";

export const projects = {
  sectionTitle: i18next.t("projects.sectionTitle"),
  icon: null,
  description: i18next.t("projects.description"),
  categories: [
    {
      name: i18next.t("projects.academic.name"),
      list: [
        {
          url: i18next.t("projects.academic.latitude.url"),
          title: i18next.t("projects.academic.latitude.title"),
          description: i18next.t("projects.academic.latitude.description"),
        },
        {
          url: i18next.t("projects.academic.itrac.url"),
          title: i18next.t("projects.academic.itrac.title"),
          description: i18next.t("projects.academic.itrac.description"),
        },
        {
          url: i18next.t("projects.academic.doarti.url"),
          title: i18next.t("projects.academic.doarti.title"),
          description: i18next.t("projects.academic.doarti.description"),
        },
        {
          url: i18next.t("projects.academic.eupescador.url"),
          title: i18next.t("projects.academic.eupescador.title"),
          description: i18next.t("projects.academic.eupescador.description"),
        },
      ],
    },
    {
      name: i18next.t("projects.community.name"),
      list: [
        {
          url: i18next.t("projects.community.startcoding.url"),
          title: i18next.t("projects.community.startcoding.title"),
          description: i18next.t("projects.community.startcoding.description"),
        },
        {
          url: i18next.t("projects.community.orcestra.url"),
          title: i18next.t("projects.community.orcestra.title"),
          description: i18next.t("projects.community.orcestra.description"),
        },
        {
          url: i18next.t("projects.community.gloria.url"),
          title: i18next.t("projects.community.gloria.title"),
          description: i18next.t("projects.community.gloria.description"),
        },
      ],
    },
  ],
};

export default projects;
